// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"af655bf769f9439b","487":"3ff45186c60d1e60","868":"df356645965e368e","921":"773ed438fd238f84"}[chunkId] + ".js";
};